import React from 'react';
import { SvgIcon } from '@mui/material';

function AddAttachmentIcon() {
  return (
    <SvgIcon width="21" height="16" viewBox="0 0 21 16" fill="none">
      <path
        d={`M5.5 9.5H11.55C11.34 9.97 11.18 10.47 11.09 11H5.5C2.46 11 0 8.54 0 5.5C0 2.46 2.46 0 5.5 0H16C18.21 0 
        20 1.79 20 4C20 4.91 19.69 5.74 19.17 6.41C18.63 6.2 18.05 6.07 17.45 6.03C17.8822 5.72344 18.2055 5.28725 
        18.3732 4.78462C18.5409 4.28199 18.5442 3.73903 18.3827 3.23439C18.2212 2.72974 17.9032 2.28963 17.4748 
        1.9778C17.0464 1.66597 16.5299 1.49863 16 1.5H5.5C3.29 1.5 1.5 3.29 1.5 5.5C1.5 7.71 3.29 9.5 5.5 9.5ZM7.5 
        6.5C6.95 6.5 6.5 6.05 6.5 5.5C6.5 4.95 6.95 4.5 7.5 4.5H15V3H7.5C6.83696 3 6.20107 3.26339 5.73223 
        3.73223C5.26339 4.20107 5 4.83696 5 5.5C5 6.16304 5.26339 6.79893 5.73223 7.26777C6.20107 7.73661 6.83696 8 
        7.5 8H12.54C13.1134 7.35617 13.8196 6.8444 14.61 6.5H7.5ZM18 11V8H16V11H13V13H16V16H18V13H21V11H18Z`}
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default AddAttachmentIcon;
